document.addEventListener('DOMContentLoaded', () =>{
  var mainSwiper = new Swiper(".slideshow-wrapper.swiper",{
    slidesPerView: 1,
    autoplay: {
      delay: 3000
    },
    navigation:{
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    breakpoints: { 
      320: { 
        autoHeight: true 
      }, 
      768: { 
        autoHeight: false 
      } 
    }
  });
});
